import * as React from 'react'
import { styled, keyframes } from 'styled-components'
import { RD } from '@packages/prelude'
import { Button } from 'react-bootstrap'
import type { SubmissionResult, SubmissionType } from './PurchaseForm'

// Animation for slide-in from bottom
const slideInFromBottom = keyframes`
  from {
    transform: translateY(16px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

const AnimatedContainer = styled.div`
  animation: ${slideInFromBottom} 0.5s ease-out;
`

const RequestContainer = styled.div`
  border-top: 1px solid #475569;
  padding-top: 2rem;
`

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 1.5rem;
`

const Title = styled.h3`
  color: white;
  margin: 0;
`

interface FormSubmitProps {
  title: string
  submissionType: SubmissionType
  submissionState: RD.RemoteData<Error, SubmissionResult>
  handleBack: () => void
  submitButtonText: string
}

export const FormSubmit: React.FC<React.PropsWithChildren<FormSubmitProps>> = ({
  children,
  title,
  submitButtonText,
  submissionType,
  submissionState,
  handleBack
}) => {
  const isSubmitting = RD.isPending(submissionState) || RD.isSuccess(submissionState)

  return (
    <AnimatedContainer>
      <RequestContainer>
        <HeaderContainer>
          <Button onClick={handleBack}>
            <i className="rt-arrow-left" />
          </Button>
          <Title>{title}</Title>
        </HeaderContainer>

        {children}

        <input type="hidden" name="submissionType" value={submissionType} />

        <Button type="submit" disabled={isSubmitting} variant="secondary" className="mt-5">
          {submitButtonText}
        </Button>
      </RequestContainer>
    </AnimatedContainer>
  )
}
